import produce from 'immer';

const INITIAL_STATE = {
  list: [],
  registry: {},
  loading: false,
  saving: false,
  error: false
};

export default function project(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@projects/INDEX_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
      });

    case '@projects/CREATE_REQUEST':
    case '@projects/UPDATE_REQUEST':
    case '@projects/DELETE_REQUEST':
      return produce(state, draft => {
        draft.saving = true;
        draft.error = false;
      });

    case '@projects/READ_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
      });

    case '@projects/CREATE_SUCCESS':
    case '@projects/UPDATE_SUCCESS':
    case '@projects/DELETE_SUCCESS':
      return produce(state, draft => {
        draft.saving = false;
      });

    case '@projects/INDEX_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.list = action.payload.data;
      });

    case '@projects/READ_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.registry = action.payload.data;
      });

    case '@projects/INDEX_FAILURE':
    case '@projects/CREATE_FAILURE':
    case '@projects/UPDATE_FAILURE':
    case '@projects/DELETE_FAILURE':
      return produce(state, draft => {
        draft.saving = false;
        draft.error = true;
      });

    case '@projects/READ_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
        draft.registry = {};
      });

    default:
      return state;
  }
}
